export default "__VITE_ASSET__DO27ytFJ__"